import { render, staticRenderFns } from "./SubnetPanelBoardShow.vue?vue&type=template&id=63232510&"
import script from "./SubnetPanelBoardShow.vue?vue&type=script&lang=js&"
export * from "./SubnetPanelBoardShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports